var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12195_381)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#D3DCEA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6083 8.09527L13.3227 10L19.3227 11V5L17.0506 6.89334C16.3303 6.36748 15.5016 5.99618 14.6164 5.81113C13.1845 5.51183 11.6932 5.71825 10.3965 6.39522C9.09982 7.0722 8.07797 8.17785 7.50508 9.52377C6.93219 10.8697 6.8437 12.3726 7.2547 13.7765C7.66569 15.1803 8.55074 16.3982 9.75904 17.2227C10.9673 18.0472 12.4241 18.4272 13.8812 18.2979C15.3382 18.1687 16.7054 17.5383 17.7498 16.514C18.7941 15.4898 19.451 14.1351 19.6085 12.6809L17.8209 12.4872C17.7081 13.5279 17.2381 14.4973 16.4907 15.2303C15.7434 15.9632 14.765 16.4144 13.7223 16.5068C12.6797 16.5993 11.6372 16.3274 10.7725 15.7374C9.90784 15.1474 9.2745 14.2759 8.98039 13.2713C8.68628 12.2667 8.7496 11.1912 9.15956 10.228C9.56952 9.26485 10.3008 8.47364 11.2287 7.98919C12.1566 7.50474 13.2238 7.35702 14.2484 7.57121C14.7306 7.67201 15.1894 7.85003 15.6083 8.09527Z",
    fill: "#7C8092"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12195_381",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12195_381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12195_381",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryIcon);
export default __webpack_public_path__ + "static/media/retry-icon.15086624012a95b7be61c34bec63cfd2.svg";
export { ForwardRef as ReactComponent };